/* cuptural B2B cart discount refresh - Safari safe */
(() => {
  if (window.__cupturalB2BDiscountRefresh) return;
  window.__cupturalB2BDiscountRefresh = true;

  const isCart = location.pathname === '/cart' || location.pathname.endsWith('/cart');
  if (!isCart) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const storageKey = 'cuptural-b2b-cart-refreshed-signature-v2';

  fetch(`${root}cart.js`, {
    credentials: 'same-origin',
    cache: 'no-store',
    headers: { Accept: 'application/json' }
  })
    .then(r => r.ok ? r.json() : Promise.reject(new Error('cart.js failed')))
    .then(cart => {
      const items = Array.isArray(cart.items) ? cart.items : [];
      const hasB2B = items.some(item =>
        /·\s*B2B\b/i.test(item.product_title || '') || /\bB2B\b/i.test(item.title || '')
      );
      if (!hasB2B) return;

      const signature = items
        .map(item => `${item.key}:${item.quantity}`)
        .sort()
        .join('|');

      if (sessionStorage.getItem(storageKey) === signature) return;
      sessionStorage.setItem(storageKey, signature);

      const updates = {};
      items.forEach(item => { updates[item.key] = item.quantity; });

      return fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      }).then(r => {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      }).then(() => location.reload());
    })
    .catch(() => {
      try { sessionStorage.removeItem(storageKey); } catch (e) {}
    });
})();

/* cuptural B2B conditions - homepage */
(() => {
  if (location.pathname !== '/' && location.pathname !== '') return;
  const updateConditions = () => {
    const headings = Array.from(document.querySelectorAll('h1, h2, h3'));
    const heading = headings.find(el => el.textContent.trim().toLowerCase() === 'condiciones para clientes profesionales');
    if (!heading) return;
    const section = heading.closest('.shopify-section');
    if (!section) return;
    const textBlock = section.querySelector('.rich-text__text');
    if (!textBlock || textBlock.dataset.cupturalB2bUpdated === '1') return;
    textBlock.dataset.cupturalB2bUpdated = '1';
    textBlock.innerHTML = `
      <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(240px,1fr));gap:24px;margin:8px 0 26px;">
        <div>
          <p style="font-size:1.25em;margin:0 0 10px;"><strong>Formato 250 g</strong></p>
          <p style="margin:0 0 7px;"><strong>12–19 bolsas</strong> · Tarifa B2B incluida en el precio.</p>
          <p style="margin:0;"><strong>Desde 20 bolsas</strong> · Tarifa volumen equivalente a un 30% de descuento sobre el PVP.</p>
        </div>
        <div>
          <p style="font-size:1.25em;margin:0 0 10px;"><strong>Formato 1 kg</strong></p>
          <p style="margin:0 0 7px;"><strong>3–9 kg</strong> · Tarifa wholesale incluida en el precio.</p>
          <p style="margin:0 0 7px;"><strong>10–19 kg</strong> · 10% de descuento adicional sobre la tarifa wholesale.</p>
          <p style="margin:0;"><strong>Desde 20 kg</strong> · 15% de descuento adicional sobre la tarifa wholesale.</p>
        </div>
      </div>
      <p><strong>Puedes combinar diferentes cafés</strong> del mismo formato para alcanzar cada tramo de volumen. Los formatos de 250 g y 1 kg se calculan por separado.</p>
      <p><strong>Envío incluido en Canarias.</strong></p>
      <p><strong>Preparación y entrega:</strong> tostamos y preparamos los pedidos en 48–72 horas laborables. El transporte suele tardar 24–72 horas según destino y volumen.</p>`;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateConditions);
  else updateConditions();
})();
